import { Button } from '@mantine/core';
import { IconMessages } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';
import { AnimatePresence } from 'motion/react';
import { useMemo } from 'react';

import classes from './$id.module.css';
import { ComponentGrid } from '#components/dashboard/components/ComponentGrid';
import { useDashboardBookmarks } from '#hooks/useDashboardBookmarks';

export const Route = createFileRoute('/bookmarks/$id')({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const [bookmarks] = useDashboardBookmarks();
  const bookmark = useMemo(() => bookmarks.find((item) => item.title === id), [id, bookmarks]);
  if (!bookmark) {
    return null;
  }

  const { title, description } = bookmark;

  return (
    <div className={classes.preview}>
      <header className={classes.previewHeader}>
        <div className={classes.title}>{title}</div>
        <Button size="xs" leftSection={<IconMessages size={16} />} variant="subtle">
          Chat with dashboard
        </Button>
      </header>
      <div className={classes.content}>
        <div className={classes.description}>{description}</div>
        <div className={classes.dashboard}>
          <AnimatePresence>
            <ComponentGrid layout={bookmark.layout} description={bookmark.description}>
              {bookmark.charts}
            </ComponentGrid>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
